import { useOrganizationAccountsQuery } from './useOrganizationAccountsQuery';
import { useOrganizationAccountsSearch } from './useOrganizationAccountsSearch';
import { columns } from '../tables/columns';

export const useOrganizationAccounts = (filters: Record<string, string> = {}) => {
    const { data: items = [], isLoading: loading } = useOrganizationAccountsQuery(filters);
    const { keyword } = useOrganizationAccountsSearch();

    // Filter items based on keyword (client-side filtering)
    const visibleItems = items.filter(item =>
        !keyword ||
        item.accountId?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.account?.email?.toLowerCase().includes(keyword.toLowerCase())
    );

    return {
        items,
        visibleItems,
        loading,
        columns,
    };
};
